export const actions = {
  SET_ORGANIZATION: 'CONTEXT::SET_ORGANIZATION',
  REMOVE_ORGANIZATION: 'CONTEXT::REMOVE_ORGANIZATION',
  SET_BROWSE: 'CONTEXT::SET_BROWSE',
};

export function setOrganization(organization) {
  return {
    type: actions.SET_ORGANIZATION,
    payload: {
      organization,
    },
  };
}

export function removeOrganization() {
  return {type: actions.REMOVE_ORGANIZATION};
}

export function setBrowseContext() {
  return {type: actions.SET_BROWSE};
}
